export const LANDING = '/';
